import React, { Dispatch, ReactNode, SetStateAction } from 'react';

// Material ui
import { Grid, IconButton } from '@material-ui/core';

// Variables
import VARIABLES from '@/assets/variables';

// Icons
import {
    ChevronSmallLeft,
    ChevronSmallRight
} from '@/assets/icons';

// Styles
import './Menu.scss';

export const MenuContext = React.createContext({ expanded: true });

interface Props {
    expanded: boolean,
    children: ReactNode,
    setExpanded: Dispatch<SetStateAction<boolean>>
}

const Menu: React.FC<Props> = ({
    expanded,
    children,
    setExpanded
}) => (
    <>
        <MenuContext.Provider
            value={{ expanded }}
        >
            <Grid
                className="ui-Menu"
                style={{
                    width: expanded ? VARIABLES.menu.width_expanded : VARIABLES.menu.width_collapsed
                }}
            >
                <IconButton
                    className="ui-Menu-expand-button"
                    onClick={() => setExpanded((prevState: boolean) => !prevState)}
                >
                    { expanded ? (
                        <ChevronSmallLeft
                            color="#FFFFFF"
                            width="16"
                            height="16"
                            className="ui-Expand-icon"
                        />
                    ) : (
                        <ChevronSmallRight
                            color="#FFFFFF"
                            width="16"
                            height="16"
                            className="ui-Expand-icon"
                        />
                    )}
                </IconButton>
                <Grid
                    className="ui-Menu-Header"
                >
                    <img
                        src="/Simbolo.svg"
                        width="33"
                        height="37"
                        alt="Alquileres Online"
                    />
                    <img
                        style={{
                            marginLeft: '.5rem',
                            transition: expanded ? 'ease 1s' : 'none',
                            pointerEvents: expanded ? 'auto' : 'none',
                            opacity: expanded ? 1 : 0
                        }}
                        src="/Nombre.svg"
                        width="63"
                        height="25"
                        alt="Alquileres Online"
                    />
                </Grid>
                <Grid
                    className="ui-Menu-List"
                >
                    {children}
                </Grid>
            </Grid>
        </MenuContext.Provider>
    </>
);

export default Menu;
